define('home/templates/homepageNoChannelsFeedEmpty',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var alias1=container.escapeExpression, alias2=container.lambda;

  return "<div class=\"card--empty text-center\">\n<div class=\"empty-message\">\n\n<img class=\"empty-message__img\" src=\""
    + alias1(helpers.urlfor.call(depth0 != null ? depth0 : {},"cdn",{"name":"urlfor","hash":{},"data":data}))
    + "/img/empty-states/"
    + alias1(alias2((depth0 != null ? depth0.emptyImage : depth0), depth0))
    + "\"/>\n\n<div class=\"empty-message__content\">\n<h2 class=\"text-larger\">\n"
    + alias1(alias2((depth0 != null ? depth0.mainText : depth0), depth0))
    + "\n</h2>\n<p class=\"text-gray text-medium\">\n"
    + alias1(alias2((depth0 != null ? depth0.subText : depth0), depth0))
    + "\n</p>\n<a href=\""
    + alias1(alias2((depth0 != null ? depth0.followButtonUrl : depth0), depth0))
    + "\" class=\"button button-outline button-padding-wider text-large\">\n"
    + alias1(alias2((depth0 != null ? depth0.followText : depth0), depth0))
    + "\n</a>\n</div>\n</div>\n</div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : {},(depth0 != null ? depth0.isLoggedIn : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"useData":true})

});
